// extracted by mini-css-extract-plugin
module.exports = {"editContainer":"agents-module__editContainer___13rOd"};